export const LCA_ORIGINATOR_PARTY_ROLE_ID  = 134;
export const DEFAULTS = {
    COMPANY_CLASSIFICATION: '7', // CAT 7 (Sole Traders, Partnerships, Private Companies)
    COMPANY_TYPE: 'private-company'
};

export const RETAIL = {
  LCA: 134,
  FMCDIRECT: 176946
};

export const CHANNEL = {
  FMC: 'tps',
  LCA: 'lca',
};
